import type {Location} from "@khan/urls";

/**
 * Get the continue URL from the location object.
 * If the continue URL contains a protocol or hostname, it will be removed.
 * @param location The location object.
 * @returns The continue URL (path) OR null if not found.
 */
export const getContinueUrl = (location: Location): null | string => {
    const queries = location.queryParams;
    const continueUrl = queries["continue"] || "";
    if (!continueUrl) {
        return null;
    }
    // If continue URL from window.location has the protocol or hostname or
    // both, replace them so that only the relative path remains.
    const continuePath = continueUrl
        .replace(location.protocol + "//", "") // protocol is like "https:"
        .replace(location.host, "");

    return continuePath;
};
